import "./HeroImg2Styles.css";
import React, { Component } from "react";

class HeroImg2 extends Component {
  render() {
    const { heading, text, imageSrc } = this.props;  

    return (
      <div
        className="hero-img"
        style={{
          backgroundImage: imageSrc ? `url(${imageSrc})` : 'none', 
        }}
      >
        <div className="heading">
          <h1>{heading}</h1>
          <p>{text}</p> 
        </div>
      </div>
    );
  }
}

export default HeroImg2;
